export {
    Loading,
    Loading as default,
    Types,
} from './loading.component';

export {LoadingHolder} from './loading-holder.component';

export type {HolderProps} from './loading-holder.component';
export type {Props} from './loading.component';
